//@flow
import React, {useState, useEffect} from 'react';
import {
  makeStyles,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@material-ui/core';

import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';

import InlineLoader from '../../../../../elements/LoadingSpinner/InlineLoader';
import {
  useTaxInvoiceSetting,
  useTaxInvoiceSettingActions,
} from '../../../../tax-invoice/utils';

import type {TaxInvoiceSettingRequest} from '../../../../../entities';

import type {Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'grid',
    placeItems: 'center',
    background: 'rgba(255,255,255,.5)',
    zIndex: 1,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

type SaleRecipe = {
  id: string,
  singular: string,
  plural: string,
  enabled?: boolean,
};

const SALE_RECIPE_LABELS: SaleRecipe[] = [
  {
    id: 'boleta',
    singular: 'Boleta',
    plural: 'Boletas',
    enabled: false,
  },
  {
    id: 'factura',
    singular: 'Factura',
    plural: 'Facturas',
    enabled: false,
  },
];

export default function SaleRecipes() {
  const classes = useStyles();

  const [enabledRecipes, setEnabledRecipes] = useState<SaleRecipe[]>(
    SALE_RECIPE_LABELS
  );

  const [enableRecipeConfig, setEnableRecipeConfig] = useState(false);

  const taxInvoiceSetting = useTaxInvoiceSetting();
  const {setTaxInvoiceSetting, loading} = useTaxInvoiceSettingActions();

  console.log({
    taxInvoiceSetting,
  });

  useEffect(() => {
    if (!taxInvoiceSetting) return;
    setEnableRecipeConfig(taxInvoiceSetting.enabled);
    const enabledRecipes = SALE_RECIPE_LABELS.map(recipe => {
      return {
        ...recipe,
        enabled: taxInvoiceSetting.taxInvoiceSetting[recipe.id.toUpperCase()],
      };
    });
    setEnabledRecipes(enabledRecipes);
  }, [taxInvoiceSetting]);

  const handleSaveSaleRecipeConfig = ({
    enabled,
    enabledTaxInvoices,
  }: {
    enabled?: boolean,
    enabledTaxInvoices?: SaleRecipe[],
  }) => {
    const taxInvoiceSetting = enabledTaxInvoices ?? enabledRecipes;

    const taxInvoiceSettingsRequest: TaxInvoiceSettingRequest = {
      enabled: enabled ?? enableRecipeConfig,
      taxInvoiceSetting: taxInvoiceSetting.reduce((acc, recipe) => {
        acc[recipe.id] = recipe.enabled;
        return acc;
      }, {}),
    };

    setTaxInvoiceSetting(taxInvoiceSettingsRequest);
  };

  const handleToggleEnabledRecipe = (recipe: SaleRecipe) => {
    const newRecipes = enabledRecipes.map(enabledRecipe => {
      if (enabledRecipe.id === recipe.id) {
        return {
          ...enabledRecipe,
          enabled: !enabledRecipe.enabled,
        };
      }
      return enabledRecipe;
    });

    handleSaveSaleRecipeConfig({
      enabledTaxInvoices: newRecipes,
    });

    setEnabledRecipes(newRecipes);
  };

  const handleToggleTaxInvoiceConfig = () => {
    setEnableRecipeConfig(prev => {
      handleSaveSaleRecipeConfig({
        enabled: !prev,
      });

      return !prev;
    });
  };

  return (
    <div className={classes.root}>
      {loading && (
        <div className={classes.loader}>
          <InlineLoader loading={loading} />
        </div>
      )}
      <header className={classes.header}>
        <Typography>Emitir comprobante</Typography>
        <FormControlLabel
          labelPlacement="start"
          control={
            <IosSwitch
              checked={enableRecipeConfig}
              size="medium"
              color="primary"
              onChange={handleToggleTaxInvoiceConfig}
            />
          }
          label={enableRecipeConfig ? 'Activado' : 'Desactivado'}
        />
      </header>
      {enabledRecipes.map(saleRecipe => (
        <FormControlLabel
          key={saleRecipe.id}
          control={
            <Checkbox
              checked={saleRecipe.enabled}
              size="medium"
              color="primary"
              onChange={() => handleToggleEnabledRecipe(saleRecipe)}
            />
          }
          label={<span>{saleRecipe.plural}</span>}
        />
      ))}
    </div>
  );
}
